module.exports = __webpack_public_path__ + "static/media/75565464968f2b2cd5155d20e77164a2.85c0e4b5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/thumbs/75565464968f2b2cd5155d20e77164a2.jpg
// module id = 297
// module chunks = 0